const poems = {
  "la-poesia": {
    title: "La Poesía",
    body: `
    La poesía es una forma de expresarse <br/>
    Que nace en el alma ... <br/>
    Se sublima con la palabra ... <br/>
    Y trasciende a la eternidad ... <br/>
    <br/>
    La poesía no es mercancía <br/>
    que se compra con dinero ...<br/>
    ni se aprende en la escuela.<br/>
    Es un sentimiento profundo y divino<br/>
    que todos llevamos dentro ...<br/>
    pero que pocos sacamos fuera ...<br/>
    <br/>
    La poesía es el amor a todo lo que existe<br/>
    es inventar la palabra ...<br/>
    que da vida a la muerte<br/>
    para seguir el camino de la inmortalidad.`,
    footer: "J.G.T 1972. ",
  },
  "el-amor": {
    title: "El Amor",
    body: `
    El amor ... es el alimento<br/>
    con el que los hombres se nutren<br/>
    para lograr liberarse<br/>
    del sufrimiento, que causa<br/>
    ¡¡El Egoísmo!!`,
    footer: "Jorge G. T. Mayo 1993 N/A ",
  },
  ausencia: {
    title: "Ausencia",
    body: `
    La ausencia en la vida<br/>
    es remota ...<br/>
    la ausencia en la muerte<br/>
    eterna ...<br/>
    <br/>
    En la vida he vuelto a ti<br/>
    y te he querido tanto<br/>
    como cuando de ti me fui<br/>
    <br/>
    En la muerte ...<br/>
    me iré queriéndote<br/>
    para nunca más volver<br/>
    <br/>
    El castigo de quererte<br/>
    para mí ... será morir<br/>
    porque muerto<br/>
    jamás te volveré a querer. `,
    footer: "J.G.T. Septiembre 1953 ",
  },
  "pienso-en-ti": {
    title: "Pienso En Ti",
    body: `
    Estudio y te recuerdo<br/>
    en el día y en la noche<br/>
    me acompañas<br/>
    <br/>
    Que hay por hacer en el hacer de mi vida<br/>
    para seguir pensando en ti<br/>
    si tú eres mi propio hacer<br/>
    y todo lo que hago lo hago pensando en ti<br/>
    <br/>
    Un día te conocí ... y pensé en ti tanto<br/>
    que ahora no puedo hacer algo sin estar pensando en ti.<br/>
    <br/>
    Y hoy ... mañana y siempre ... seguiré pensando en ti<br/>
    hasta el fin de mi existencia en que dejé de vivir<br/>
    <br/>
    Pero allá. .. en el más allá<br/>
    no sé sí estarás en mi<br/>
    porque no siendo lo que soy aquí<br/>
    tú no serás en mí.<br/>
    <br/>
    Amor, que me importa el más allá<br/>
    cuando estoy aquí ... siempre pensando en ti. `,
    footer: "J.G.T.",
  },
  "brilla-una-estrella": {
    title: "Brilla Una Estrella",
    body: `
    A11á en lo alto del cielo del caribe...<br/>
    brilla una estrella<br/>
    es el alma del hombre que en la guerra<br/>
    perdió la vida por salvar la tierra<br/>
    por salvar la tierra ... que le dio la vida<br/>
    <br/>
    Allá en lo alto del cielo del caribe...<br/>
    brilla una estrella<br/>
    es el alma del poeta ... que con sus loas<br/>
    y palabras bullangueras<br/>
    salvó a su patria del tirano de ella<br/>
    <br/>
    Allá en lo alto del cielo del caribe<br/>
    brilla una estrella<br/>
    es el alma del pueblo que en cadenas...<br/>
    rompió en la lucha, la maldad de ellas<br/>
    <br/>
    Allá en lo alto del cielo del caribe...<br/>
    brilla... una estrella.`,
    footer: "J.G.T. Julio de 1961",
  },
  "la-invasion-a-cuba": {
    title: "La Invasión A Cuba",
    body: `
    Es que a Cuba ya llegó<br/>
    la invasión premeditada<br/>
    que pagada por los Yankees<br/>
    desembarco de mañana<br/>
    <br/>
    Fue la bahía de cochinos<br/>
    la que recibió a los gringos<br/>
    y en esa misma bahía<br/>
    quedaron muertos los Yankees<br/>
    revolcándose en el lodo<br/>
    como todos los cochinos<br/>
    <br/>
    Cuba entera respondió<br/>
    al llamado de Fidel<br/>
    con las armas en la mano<br/>
    acudieron al cuartel<br/>
    <br/>
    ¡¡Adelante!!... ¡¡Venceremos!!<br/>
    Milicianos y soldados<br/>
    a los Yankees mataremos<br/>
    <br/>
    Todo fue en cuestión de horas<br/>
    porque el pueblo enfurecido<br/>
    arremetió sin demora<br/>
    <br/>
    Y en el campo de batalla<br/>
    en las villas, y en jaguey<br/>
    los soldados de Fidel<br/>
    lucharon a pura ley<br/>
    <br/>
    Tanques, aviones, granadas<br/>
    acabaron la invasión<br/>
    ya no les quedaron ganas<br/>
    a mercenarios y Yankees<br/>
    de recibir más lección<br/>
    <br/>
    Hay cubita de mi vida<br/>
    te dedico este mensaje<br/>
    a tu heroico pueblo valiente<br/>
    y a Kennedy... su coraje.`,
    footer: "J.G.T.",
  },
  duerme: {
    title: "Duerme",
    body: `
    Duerme amada<br/>
    duerme tranquila<br/>
    El sueño ingenuo<br/>
    Que te da la vida<br/>
    <br/>
    Duerme amada<br/>
    duerme con el corazón<br/>
    pensando en que mañana<br/>
    se abrirán tus ojos<br/>
    con la luz de una mañana<br/>
    <br/>
    Duerme amada<br/>
    duerme con tus brazos flojos<br/>
    para que mañana<br/>
    acaricies con tus manos<br/>
    la tersura de tus labios rojos<br/>
    <br/>
    Duerme amada<br/>
    duerme tranquila<br/>
    y espera que en tus sueños<br/>
    encuentres la paz y la alegría<br/>
    que no encontraste en el día<br/>
    <br/>
    Duerme amada<br/>
    duerme con tus cienes<br/>
    siempre puestas en la almohada<br/>
    un sueño eterno lleno de alegrías. `,
    footer: "J.G.T. Mayo 10 de 1961. ",
  },
  "los-muertos": {
    title: "Los Muertos",
    body: `
    Porqué lloran los hombres<br/>
    cuando muerto encuentran<br/>
    al hombre que en vida<br/>
    lloraba a los muertos<br/>
    <br/>
    Porqué lloran los vivos<br/>
    con pasión ardiente<br/>
    al paso del féretro<br/>
    que arrastran dolientes<br/>
    <br/>
    Porqué lloran los hombres<br/>
    cuando en el descanso<br/>
    se tienden los muertos<br/>
    cuando ya en la tumba<br/>
    se quedan dormidos<br/>
    <br/>
    Porqué lloran los hombres<br/>
    si sus pobres lágrimas<br/>
    no bañan la tierra<br/>
    donde están dormidos<br/>
    <br/>
    Porqué lloran los hombres<br/>
    si sus pobres lágrimas<br/>
    no llegan al cielo<br/>
    a pedir justicia<br/>
    a implorar consuelo`,
    footer: "J.G.T. Enero 1962 ",
  },
  "el-infinito-incierto": {
    title: "El Infinito Incierto",
    body: `
    Quiero sentir tu vida<br/>
    con mis manos acariciar tu cuerpo<br/>
    ser como tú, un mismo cuerpo<br/>
    y nuestras almas juntas seguir siempre unidas<br/>
    <br/>
    No regresar jamás a la tierra<br/>
    por cruzar unidos el infinito cielo<br/>
    y acariciar de cerca al Dios perdido<br/>
    en el inmenso cielo donde está dormido<br/>
    <br/>
    Volar... vagar... cruzar siempre unidos<br/>
    <br/>
    De estrella a estrella el infinito cielo<br/>
    y llegar por fin al punto ciego<br/>
    a empezar de nuevo... a surcar el cielo.`,
    footer: "J.G.T. Enero de 1964 ",
  },
  tormenta: {
    title: "Tormenta",
    body: `
    Nubarrones que giran<br/>
    como laberinto...<br/>
    obscureciendo solo<br/>
    el brillo opaco de tus ojos<br/>
    <br/>
    Relámpagos furia<br/>
    de los cielos...<br/>
    que iluminan lo más profundo y obscuro<br/>
    de tus sueños...<br/>
    <br/>
    Tormenta relumbrante<br/>
    de tu vida...<br/>
    que opaca la luz de tus anhelos...<br/>
    <br/>
    Retoma el camino de tus sueños...<br/>
    despierta con el ruido de los rayos,<br/>
    con la luz apacible de los años,<br/>
    el olor discreto de los nardos...<br/>
    y el canto melodioso de las aves...`,
    footer: "J.G.T. Noviembre de 1966 ",
  },
  "sonar-con-los-ojos-abiertos": {
    title: "Soñar Con Los Ojos Abiertos",
    body: `
    Quiero soñar con los ojos abiertos<br/>
    soñar... cuando gime el viento<br/>
    y sentir de cerca tu adorado aliento<br/>
    <br/>
    Trasladar mi sueño con el tuyo<br/>
    y fundir de cerca nuestras almas<br/>
    en el supremo crisol del tiempo y de la nada<br/>
    <br/>
    Y por fin unidos en amalgama eterno<br/>
    vagar errantes, sin límite de tiempo y de distancias<br/>
    juntos al fin, en el infinito acierto del deseo. `,
    footer: "J.G.T. Julio 25 de 1967 ",
  },
  recuerdos: {
    title: "Recuerdos",
    body: `
    Cuando triste y solo<br/>
    me encuentro en mi vida
    no sé lo que pienso<br/>
    no sé lo que imploro<br/>
    <br/>
    Baña de recuerdos<br/>
    mi mente intranquila<br/>
    aquellos momentos<br/>
    en que fuiste mía<br/>
    <br/>
    Aquellos instantes<br/>
    en que me decías<br/>
    siempre tuya soy<br/>
    soy tuya mi vida<br/>
    <br/>
    Y hoy solo en la vida
    triste y solo pienso<br/>
    aquellos instantes<br/>
    en que fuiste mía. `,
    footer: "J.G.T. Febrero 20 de 1967 ",
  },
  "el-poder-del-amo": {
    title: "El Poder Del Amo",
    body: `
    Ya no corre el río ... ya no suena el agua<br/>
    ya las aves no han pasado<br/>
    ya la lluvia se ha alejado<br/>
    <br/>
    Cuando hoy por la mañana<br/>
    temprano he despertado<br/>
    tome mis cuadernos<br/>
    para ir a mi escuela<br/>
    <br/>
    Corría por la calle como otras mañanas<br/>
    la gente asustada salía de sus casas<br/>
    gritando decían que allá en mi escuela<br/>
    El amo lanzaba a todos a palos<br/>
    <br/>
    Apresurado llegaba a mi escuela<br/>
    que ya sin alumnos, y sin mi maestra<br/>
    y sin nadie en el patio ... se estaba quemando<br/>
    <br/>
    Lloré de repente ... seguí yo llorando<br/>
    ya nada en mi escuela ... sola y triste ha estado<br/>
    se acercó a mi frente ... un hombre de verde<br/>
    son saña en su cara, me dijo con fuerza<br/>
    sal ya de esta escuela ... y lárgate lejos<br/>
    <br/>
    Es cuartel tu escuela<br/>
    el amo lo ha dicho<br/>
    Ordaz lo ha ordenado. `,
    footer: "J.G.T. Julio de 1968",
  },
  "te-quiero": {
    title: "Te Quiero",
    body: `
    Te quiero porque te quiero<br/>
    Te quiero más que a mi vida<br/>
    Te quiero más que a mi alma<br/>
    Te quiero porque eres mía<br/>
    <br/>
    Te quiero porque eres alma<br/>
    Te quiero porque eres vida<br/>
    Te quiero porque te quiero<br/>
    Te quiero porque eres mi alma. `,
    footer: "J.G.T. Febrero de 1968",
  },
  "al-mar": {
    title: "Al Mar",
    body: `
    Oye mar... porqué descargas tu fuerza en la arena<br/>
    <br/>
    Porqué acaricias la playa y te alejas<br/>
    y con tu silencio te vas con mi alma<br/>
    <br/>
    Llegas con fuerza inaudita ... retrocedes<br/>
    vuelves con nuevos impulsos<br/>
    y por fin me dejas<br/>
    <br/>
    Mar... mar que te veo nacer<br/>
    y un impulso me hace creer solo en ti<br/>
    porque en ti he encontrado la paz... el silencio.<br/>
    <br/>
    Cuando triste y solo<br/>
    me siento en mi vida<br/>
    solo encuentro en ti... lo que yo soñaba<br/>
    <br/>
    Con tu arrullo intenso... domino mi nada<br/>
    y es en tu silencio<br/>
    cuando ya mi vida... se pierde... y se apaga.`,
    footer: "J.G.T. 23 Nov. De 1968 ",
  },
  "la-primera-vez": {
    title: "La Primera Vez",
    body: `
    Hoy por primera vez<br/>
    mi boca toco los labios puros de la tuya<br/>
    <br/>
    Hoy por primera vez<br/>
    vi... el rojo atardecer de tus pupilas<br/>
    <br/>
    Hoy por primera vez<br/>
    sentí el calor que de tu cuerpo emanas<br/>
    <br/>
    Hoy por primera vez<br/>
    confundí mi cuerpo con el tuyo<br/>
    <br/>
    Hoy por primera vez<br/>
    volvió a nacer en mí... la esperanza muerta. `,
    footer: "J.G.T. Febrero 18 1969 ",
  },
  "viva-cristo-rey": {
    title: "Viva Cristo Rey",
    body: `
    En verdad, en verdad os digo: que aquellos que me siguieren y no<br/>
    me negaren, no perecerán y vivirán para siempre.<br/>
    <br/>
    Con paso lento un hombre en medio de la tropa caminaba, apenas su<br/>
    cuerpo se sostenía del suelo que pisaba, parecía que su cuerpo<br/>
    flotaba en el tiempo y espacio; más fuertes eran los pasos decididos<br/>
    de la tropa, hombres, maquinas que el ingenio humano ha creado.<br/>
    <br/>
    De frente ... alto ... ya se oía una voz fuerte y ordenante.<br/>
    <br/>
    Frente a todos ellos, esperaba paciente, inmóvil, austero, seco, un<br/>
    muro de adobe y piedra sin color ... un hombre se para frente al muro,<br/>
    y a su espalda, un pelotón de fusilamiento formado por hombres sin<br/>
    razón, ni descernimiento.<br/>
    <br/>
    Por fin se escucha la voz estridente de la muerte ...<br/>
    preparen .... apunten ... ¡¡Fuego!!<br/>
    <br/>
    En medio de la orden .... una voz se escucha con claridad y fuerza que<br/>
    todos escuchan sin escuchar¡ ¡VIVA CRISTO REY!!<br/>
    <br/>
    Después el silencio rompe el ambiente de muerte ...<br/>
    se rompe el viento que leve soplaba<br/>
    apenas se aprecia el color de las flores<br/>
    el eco de las voces, el canto de las aves,<br/>
    el susurro de los presentes<br/>
    el tañir de las campanas<br/>
    <br/>
    El cuerpo de un hombre yace en<br/>
    el suelo ensangrentado por las<br/>
    balas que a su cuerpo han masacrado<br/>
    y al alma han liberado, en ese<br/>
    silencio que aún se siente y que se<br/>
    lleva dentro.`,
    footer: "J.G.T. Abril 1970",
  },
  grijalva: {
    title: "Grijalva",
    body: `
    Una sola vez te vi...<br/>
    te confundías en tu nacimiento<br/>
    con un cielo azul casi desnudo<br/>
    <br/>
    Tus aguas cristalinas y lentas...<br/>
    como el viento que soplaba<br/>
    se deslizaban junto a mí, en el silencio<br/>
    <br/>
    Bañas la tierra fértil y a tu paso ...<br/>
    los hombres se aprestan a mirarte<br/>
    que belleza es contemplarte ria Grijalva<br/>
    <br/>
    Al verte, olvido mis angustias pordioseras.<br/>
    <br/>
    Si yo pudiera volver... ya no a mirarte<br/>
    sino a mojar mi cuerpo con tus aguas<br/>
    yo sería inmaculado para siempre. `,
    footer: "J.G.T. Marzo 14 de 1970 ",
  },
  "quien-eres-tu": {
    title: "Quién Eres Tu",
    body: `
    Que tiene tu pelo largo<br/>
    que tienen tus ojos negros<br/>
    que yo no puedo tocarlos<br/>
    ni puedo tus ojos verlos<br/>
    <br/>
    Que tienen tus labios rojos<br/>
    que tiene tu piel morena<br/>
    besar tus labios no puedo<br/>
    tocar tu cuerpo no debo `,
    footer: "J.G.T. Julio 19 de 1971",
  },
  "quien-soy-yo": {
    title: "Quién Soy Yo",
    body: `
    Quien fuiste tú<br/>
    <br/>
    Yo... fui un deseo<br/>
    de un cuerpo<br/>
    al que el dolor venció<br/>
    <br/>
    Quien eres tú<br/>
    <br/>
    Yo... solo soy un cuerpo<br/>
    solo... triste, con el alma rota<br/>
    sin sentir deseo<br/>
    <br/>
    Y tú quién serás<br/>
    <br/>
    Yo... seré un mundo de deseos<br/>
    uno más... que un cuerpo tuvo<br/>
    en medio del silencio y del olvido<br/>
    <br/>
    Un sueño... que nunca empieza<br/>
    y no termina<br/>
    eso... eso soy yo. `,
    footer: "J.G.T.",
  },
  mariana: {
    title: "Mariana",
    body: `
    L1egaste a mi vida un día<br/>
    bella ... y llena de alegría<br/>
    y tu paso lento cruzó mi vida<br/>
    <br/>
    Llegaste sola<br/>
    sola ... y con el mundo a cuestas<br/>
    tu mirar lívido se impregno en el mío<br/>
    <br/>
    Y con sonrisa<br/>
    que de tus labios rojos se escapara<br/>
    te alejaste ... en medio del silencio<br/>
    de la noche y del camino. `,
    footer: "J.G.T 1974",
  },
  ofrenda: {
    title: "Ofrenda",
    body: `
    Qué más puedo darte amor mío<br/>
    si yo ... todo te entregue<br/>
    <br/>
    Desde el amanecer de mi vida<br/>
    te ofrecí esta ... y tu sin reservas<br/>
    la tomaste en tu regazo<br/>
    <br/>
    Te di, amor ... único consuelo<br/>
    que siempre nos acompaño<br/>
    <br/>
    Te di, la paz ... y tú espíritu y el mío<br/>
    se fundieron para siempre<br/>
    <br/>
    Te dí, la sabia de mi cuerpo<br/>
    y creció el árbol de tu vida<br/>
    y juntos formamos el fruto, del amor y de la dicha<br/>
    <br/>
    Yo, quisiera darte mi amor, lo que más quiero<br/>
    y lo que más quiero ... eres tú<br/>
    <br/>
    Pero eso amor ... no puedo darte<br/>
    solo un beso, y una lagrima, podría entregarte `,
    footer: "J.G.T. 5 de Marzo de 1975 ",
  },
  "sin-ti": {
    title: "Sin Ti",
    body: `
    Sin ti yo no puedo siquiera vivir<br/>
    mis noches son frías<br/>
    mis días son sin sol<br/>
    largas son las horas de intenso dolor<br/>
    <br/>
    Sin ti yo no puedo siquiera vivir<br/>
    eterno es el camino desde que te vi<br/>
    el sol, pobre sol ni luz ... ni calor<br/>
    luna sin reflejos ... luna sin amor<br/>
    <br/>
    Sin ti yo no puedo siquiera vivir<br/>
    el árbol sin hojas ... la flor sin olor<br/>
    el mar tan azul, perdió su color<br/>
    el río ya no quiere venir con mi amor<br/>
    <br/>
    Sin ti yo no puedo siquiera vivir<br/>
    ni el niño en la fuente ... ni el pájaro azul<br/>
    se ven de repente donde te encontré<br/>
    donde te besé y empecé a vivir<br/>
    <br/>
    Ven amada mía ... ven conmigo ven<br/>
    ven a devolverme lo que me enseñaste<br/>
    para yo vivir<br/>
    para yo vivir lo poco que queda en mi tarde gris`,
    footer: "J.G.T. Marzo 1975",
  },
  "el-arbol": {
    title: "El Árbol",
    body: `
    Te vi nacer un día<br/>
    cuando la tierra dejó la noche<br/>
    y el sol iluminó tu suelo<br/>
    cuando se abrió la tierra y brotase súbitamente de su vientre<br/>
    <br/>
    El cielo ... irrumpió en llanto, y con luces y cohetes<br/>
    bautizó tu cuerpo con sus aguas<br/>
    lleno de luz ... de color ... y de alegría<br/>
    creciste en medio del amor y del silencio<br/>
    <br/>
    Tu cuerpo ... antes frágil y pequeño<br/>
    ahora, fuerte, erguido y con soltura<br/>
    acaricias y besas con tus ramas<br/>
    las flores de los campos ... las aves que se posan en tus brazos<br/>
    <br/>
    Árbol divino, del vetusto suelo<br/>
    cuando te vi nacer de nuestra madre tierra<br/>
    mi vida ... ahora ya marchita por los años<br/>
    se llenó aquella vez, y aun se llena de gozo y alegría<br/>
    <br/>
    Árbol de la vida ... árbol de la muerte ...<br/>
    tu que propicias del cielo las aguas que dan vida<br/>
    y que ahora el cielo sin pensarlo te las niega<br/>
    para que mueras una vez ... y contigo muera la esperanza<br/>
    <br/>
    Y hoy ... que por última vez te veo<br/>
    de mis ojos brota una sola lágrima<br/>
    y se va ... se va ... a lo más profundo de tus plantas<br/>
    a morir contigo ... a morir sin cielo ... a morir sin agua. `,
    footer: "J.G.T Mayo 24 de 1976 ",
  },
  madre: {
    title: "Madre",
    body: `
    Cuando al mundo vine y vi por vez primera<br/>
    la divina luz del nuevo día,<br/>
    me encontré en tus brazos madre mía<br/>
    <br/>
    Tú me diste la vida, la luz y la esperanza<br/>
    tú me guiaste por el camino del bien<br/>
    y me apartaste del mal y de los vicios<br/>
    <br/>
    En tu regazo madre<br/>
    soporté las terribles epidemias que azotan a los hombres<br/>
    <br/>
    Y juntos caminamos por la vida<br/>
    en infinito andar, hasta la muerte<br/>
    <br/>
    Y hoy, que el mundo dejó tu llanto, madre<br/>
    baña la tierra fértil donde quedo muerto<br/>
    <br/>
    En tus brazos madre estoy<br/>
    pero ya estoy ¡¡Muerto!! `,
    footer: "J.G.T. Abril 25 de 1967",
  },
  "a-mi-madre": {
    title: "A Mi Madre",
    body: `
    Cuando apenas empecé a vivir<br/>
    la muerta violentamente<br/>
    aparto tu vida de la mía<br/>
    y me dejaste solo ... solo en el mundo<br/>
    al que tú, con tu sutileza de mujer<br/>
    un día me entregaste<br/>
    y en esta soledad crecí ... pero de mi mente<br/>
    nunca te apartas<br/>
    un recuerdo de ti se fijó más ... fuiste<br/>
    mujer<br/>
    integra en todos los quehaceres de la vida<br/>
    trabajaste siempre al lado de la clase<br/>
    obrera, y luchaste con ella por la causa<br/>
    revolucionaria<br/>
    dejaste al partir, un vacío que nada ni<br/>
    nadie podrá llenar<br/>
    con tu trabajo, esfuerzo y ahorro constante<br/>
    se benefician ... y beneficiaran muchas<br/>
    generaciones<br/>
    algunos apenas te recuerdan<br/>
    los más te olvidan<br/>
    pero la razón y el tiempo pondrá al fin<br/>
    a cada quien en su lugar<br/>
    y tu alcanzarás el recuerdo imborrable<br/>
    de los justos. `,
    footer: "J.G.T. 1977 ",
  },
  "carta-a-mi-madre": {
    title: "Carta A Mi Madre",
    body: `
    Mañana que es tu día, recibirás mi carta<br/>
    que es por ahora todo lo que te puedo dar<br/>
    <br/>
    Estamos tan distantes madre ...<br/>
    y han pasado tantos años desde mi partida.<br/>
    <br/>
    Que a veces pienso que ni tú ni yo existimos.<br/>
    <br/>
    En la guerra he aprendido a odiar ... pero también a amar<br/>
    he matado y curado enfermos<br/>
    <br/>
    No hay clemencia ... ni perdón<br/>
    no hay amor ... ni hay alegría<br/>
    solo hay odio ... y tiranía<br/>
    <br/>
    Recuerdo madre ... que cuando era niño<br/>
    me enseñaste madre ... el amor divino<br/>
    y hoy he aprendido también a matar<br/>
    <br/>
    Porque madre mía ... porque yo he crecido<br/>
    porque me trajeron a este infierno vivo<br/>
    <br/>
    Solo quiero madre pedir al Señor<br/>
    que vuelva contigo y me de perdón<br/>
    que juntos pasemos lo poco de vida que queda a los dos<br/>
    <br/>
    Tú eres tan buena y también tan santa<br/>
    reza madre e implora ... y pide al Señor<br/>
    que termine pronto esta guerra cruel que nos separó.`,
    footer: "J.G.T. Abril 1O de 1968",
  },
  "sin-final": {
    title: "Sin Final",
    body: `
    Apenas latía tú corazón<br/>
    cuando ya de tu cuerpo la sangre vertía<br/>
    <br/>
    Las balas asesinas, pequeños montículos de acero<br/>
    se incrustaban como espinas en tu cuerpo<br/>
    <br/>
    Quedaste solo, en medio de un ritual de silencio<br/>
    y de sollozos, ni siquiera se oía ya el latir de tú corazón inepto<br/>
    <br/>
    ¡¡Despierta Carlos!!<br/>
    <br/>
    Esto es solo un sueño ...<br/>
    <br/>
    Ni tú corazón deja de latir<br/>
    ni a tu cuerpo mancha la sangre que derramas<br/>
    <br/>
    Las balas asesinas ... no existen<br/>
    es solo ... un sueño<br/>
    <br/>
    La vida es solo tuya ... ¡¡Defiéndela!!<br/>
    <br/>
    Nadie jamás podrá quitártela<br/>
    ni tus amigos menos tus enemigos<br/>
    <br/>
    Entrega las balas asesinas, que no son tuyas<br/>
    a aquellos cobardes que sobre tu cuerpo dispararon las espinas<br/>
    <br/>
    Ya que solamente tú sabes quienes fueron. `,
    footer: "J.G.T. Septiembre de 1977 ",
  },
  "al-senor-licenciado-carlos-ramirez-ladewig": {
    title: "Al Sr. Licenciado Carlos Ramírez Ladewig",
    body: `
    Asesinado arteramente por los enemigos de los ideales y<br/>
    realizaciones revolucionarias que desde estudiante, después como<br/>
    profesionista y por ultimo como integro representante popular, siempre<br/>
    defendió con honor, con hombría y valor inmaculado.<br/>
    <br/>
    Desde muy joven se entregó a la lucha revolucionara estudiantil y sus<br/>
    conquistas fueron muchas. Entre ellas logró para la clase estudiantil<br/>
    económicamente más débil, un lugar para cada uno dentro de las<br/>
    aulas universitarias, privilegio ententes de los potentados.<br/>
    <br/>
    Las clases populares, la gran masa estudiantil, y los dignos y limpios<br/>
    ex universitarios, hemos perdido físicamente a un gran hombre,<br/>
    precisamente en el tiempo en que su preciada existencia es tan<br/>
    necesariamente imprescindible en nuestro pueblo para fortalecer la<br/>
    lucha de los grupos revolucionarios y cerrar más y más el cerco a la<br/>
    reacción y al oportunismo.<br/>
    <br/>
    Nos legó con su ejemplo y sacrificio, privilegio de los héroes como él,<br/>
    la firme convicción de que el hombre que entrega su vida en defensa<br/>
    de las causas más nobles de sus semejantes no debe morir, sigue<br/>
    viviendo junto a nosotros en una constante lucha por la libertad, la<br/>
    emancipación y la unificación indestructible del estudiantado popular.<br/>
    <br/>
    Así seguimos atentos y defenderemos como baluarte intocable los<br/>
    ideales y principio de la lucha que él inició y defendió, entregando su<br/>
    vida por ella. `,
    footer: "J.G.T.",
  },
  "una-esperanza": {
    title: "Una Esperanza",
    body: `
    El soplo de un aliento<br/>
    todo lo acabó<br/>
    <br/>
    Se extinguió la flama<br/>
    que encendía tu rostro y delineo tu cuerpo<br/>
    <br/>
    Fue apagándose poco a poco la luz<br/>
    y tu cuerpo desfigurándose<br/>
    en las sombras que momento a momento<br/>
    se perdían hasta quedar sin forma<br/>
    <br/>
    Fuiste conmigo un cuerpo<br/>
    fundido con la única luz de una esperanza<br/>
    te entregaste a mí<br/>
    pero no solo a mi. .. no fuiste mía<br/>
    <br/>
    Las sombras que dejaste al partir, siguen errantes<br/>
    no pudiste siquiera pensar en detenerlas<br/>
    y donde quiera que estés, están contigo<br/>
    <br/>
    Yo... yo no soy nada<br/>
    ni vida... ni cuerpo... ni sombra<br/>
    tú me arrancaste la vida<br/>
    <br/>
    Fundiste mi cuerpo con el tuyo ... en una sombra<br/>
    y te entregaste a un mundo<br/>
    donde no existe la luz ... ni una esperanza `,
    footer: "J.G.T. julio 15 de 1978 ",
  },
  "te-fuiste": {
    title: "Te Fuiste",
    body: `
    Quisiera poder regresar el tiempo<br/>
    para yo ... volver a vivir contigo ...<br/>
    esos momentos tan felices, hermosos y gozosos<br/>
    que tú, sólo tú me hiciste sentir<br/>
    <br/>
    ¡Porqué te fuiste! sin decirme nada ...<br/>
    porque dejaste extinguir la flama<br/>
    si ya jamás podré volver a verte<br/>
    al menos enciende con la luz de tu alma<br/>
    la mía ... que está apagada<br/>
    <br/>
    Y sí tú, de mi te olvidas,<br/>
    yo, siempre te llevaré dentro, muy dentro de mí<br/>
    en dónde nada ni nadie podrá apartarte de mí<br/>
    no es aprisionar tu alma, ni liberar la mía<br/>
    eso solo es ... revivir la flama<br/>
    que tú, sólo tú, quisiste apagar. `,
    footer: "J.G.T. 1981",
  },
  "ten-compasion-de-mi": {
    title: "Ten Compasión De Mí",
    body: `
    Cuan largas han sido las noches ...<br/>
    cuan eternas las horas ... sin poder saber de ti.<br/>
    <br/>
    ¿Dónde estás? .... ¿Por qué te fuiste?<br/>
    <br/>
    Porque dejaste apagar el amor que tu encendiste<br/>
    porque dejas morir ... aquella flor que tú me diste<br/>
    porque encadenas la luz, y la esperanza<br/>
    <br/>
    Yo ... no sé qué hacer, ni sé qué pensar, o que decir<br/>
    solo sé, que tú no estás,<br/>
    y hoy... solo puedo decir ... que te quiero mucho,<br/>
    pero mucho más que ayer<br/>
    <br/>
    Si tú rompiste las cadenas de mi libertad<br/>
    ten compasión de mí ... y únelas ya,<br/>
    <br/>
    Yo prefiero ser esclavo, teniéndote a ti,<br/>
    que ser libre, sin poder volver a verte más.`,
    footer: "J.G.T. 1981",
  },
  "la-obscuridad-y-la-luz-poema-a-un-cometa": {
    title: "La Obscuridad Y La Luz Poema A Un Cometa",
    body: `
    Lo vi con mis propios ojos ... todo lo vi<br/>
    lo sentí como mis ilusiones<br/>
    con el deseo de un niño, que espera impaciente un premio, o el regalo de un juguete<br/>
    con el ánimo de un adolecente, de conocer lo extraño<br/>
    con el silencio y paciencia, del hombre adulto que lo ve de nuevo<br/>
    <br/>
    Lo esperé como quien espera a alguien<br/>
    o a algo que no conoce<br/>
    pero si siente su presencia<br/>
    <br/>
    Jugué con él, reí con él, sufrí con él, pequé con él<br/>
    y hoy me arrepiento de no haber pecado más con él<br/>
    mi único deseo, fue tenerte a ti<br/>
    <br/>
    Poseerte, en una noche obscura nublada y sin estrellas<br/>
    con sol. .. con luna, y una densa niebla de colores<br/>
    rojos, azules, violetas y grises,<br/>
    que revoloteaban el cielo<br/>
    como aves que pasan sin siquiera percibirlas,<br/>
    en esta triste y lúgubre noche de deseos<br/>
    noche corta ... que duró un suspiro ... y tardó una eternidad<br/>
    <br/>
    Es la noche más bella, que haya yo tenido,<br/>
    en más de mil noches que pasé contigo<br/>
    es la noche de mis sueños<br/>
    la noche en que la muerte llega con su manto negro<br/>
    cobijando al cielo<br/>
    yéndose luego<br/>
    para dar paso a la luz brillante de la nueva vida<br/>
    <br/>
    Es el morir ... y nacer, de mi universo interno<br/>
    es el soñar un sueño eterno ... y despertar el mismo día<br/>
    <br/>
    Es el amor al silencio ... la meditación a la noche,<br/>
    la alegría a la luz ... la fe a la vida<br/>
    <br/>
    Es el sentir la caricia imperceptible de lo divino,<br/>
    es el cambiar el tiempo y el destino,<br/>
    es comprobar que existo ... que veo, que pienso<br/>
    es entender por fin lo exacto y preciso que es el universo<br/>
    es creer en mí mismo ... en los hombres, en el pasado<br/>
    es adivinar el futuro<br/>
    conocer el tiempo y el espacio<br/>
    <br/>
    Llorar por tu ausencia, sufrir por mi soledad<br/>
    es tener fe en tu regreso<br/>
    <br/>
    ¿Eres acaso la muerte y la resurrección?<br/>
    <br/>
    ¿Las tinieblas y la luz?<br/>
    <br/>
    ¿Quién eres tú?. `,
    footer: "J.G.T. 11 de julio de 1991 ",
  },
  "nada-puedo-hacer": {
    title: "Nada Puedo Hacer",
    body: `
    Tenemos que conceder valor y esencia<br/>
    absoluta, si nacimos<br/>
    <br/>
    Tenemos que morir aunque el nacer ... o el morir<br/>
    nos cause una dicha o un sufrimiento<br/>
    <br/>
    En el inter del nacimiento ... a la muerte<br/>
    el hombre puede hacer o dejar de hacer<br/>
    puede llegar a la cúspide de sus deseos<br/>
    o bajar a lo más profundo de sus ambiciones<br/>
    <br/>
    Con sus conocimientos increíbles puede aliviar su dolor<br/>
    o atreverse a retar a las leyes naturales<br/>
    <br/>
    Nada puede hacer el hombre en contra de lo que nace<br/>
    y cuando ya su cuerpo muere.`,
    footer: "J.G.T. Mayo de 1983",
  },
  "la-lluvia-y-tu": {
    title: "La Lluvia Y Tú",
    body: `
    Nubarrones que giran sin descanso<br/>
    llevándote en el sin fin del laberinto<br/>
    obscureciendo solo<br/>
    el brillo opaco de tus ojos<br/>
    <br/>
    Relámpagos furia de los cielos<br/>
    que iluminan<br/>
    lo más profundo<br/>
    y obscuro de tus sueños<br/>
    <br/>
    Tormenta relumbrante de tu vida<br/>
    que opaca la luz de tus anhelos<br/>
    <br/>
    Retoma el camino de tus sueños<br/>
    y despierta con el ruido de los rayos<br/>
    con la luz apacible de los años<br/>
    con el canto melodioso de las aves<br/>
    y el olor discreto de los nardos `,
    footer: "J.G.T. Marzo de 1989 ",
  },
  llanto: {
    title: "Llanto",
    body: `
    He llorado, sí ... y he llorado mucho<br/>
    para poder juntar así con mis lágrimas<br/>
    un mar trasparente y puro ...<br/>
    y limpiar con el mi alma<br/>
    de esas manchas imperceptibles,<br/>
    que han dejado en mí<br/>
    el sufrimiento y dolor<br/>
    que me tiranizan `,
    footer: "J.G.T. Enero 1992. N/A",
  },
};

const titles = [
  { name: "La Poesía", link: "la-poesia" },
  { name: "El Amor", link: "el-amor" },
  { name: "Ausencia", link: "ausencia" },
  { name: "Pienso En Ti", link: "pienso-en-ti" },
  { name: "Brilla Una Estrella", link: "brilla-una-estrella" },
  { name: "La Invasión A Cuba", link: "la-invasion-a-cuba" },
  { name: "Duerme", link: "duerme" },
  { name: "Los Muertos", link: "los-muertos" },
  { name: "El Infinito Incierto", link: "el-infinito-incierto" },
  { name: "Tormenta", link: "tormenta" },
  { name: "Soñar Con Los Ojos Abiertos", link: "sonar-con-los-ojos-abiertos" },
  { name: "Recuerdos", link: "recuerdos" },
  { name: "El Poder Del Amo", link: "el-poder-del-amo" },
  { name: "Te Quiero", link: "te-quiero" },
  { name: "Al Mar", link: "al-mar" },
  { name: "La Primera Vez", link: "la-primera-vez" },
  { name: "Viva Cristo Rey", link: "viva-cristo-rey" },
  { name: "Grijalva", link: "grijalva" },
  { name: "Quién Eres Tu", link: "quien-eres-tu" },
  { name: "Quién Soy Yo", link: "quien-soy-yo" },
  { name: "Mariana", link: "mariana" },
  { name: "Ofrenda", link: "ofrenda" },
  { name: "Sin Ti", link: "sin-ti" },
  { name: "El Árbol", link: "el-arbol" },
  { name: "Madre", link: "madre" },
  { name: "A Mi Madre", link: "a-mi-madre" },
  { name: "Carta A Mi Madre", link: "carta-a-mi-madre" },
  { name: "Sin Final", link: "sin-final" },
  {
    name: "Al Sr. Licenciado Carlos Ramírez Ladewig",
    link: "al-senor-licenciado-carlos-ramirez-ladewig",
  },
  { name: "Una Esperanza", link: "una-esperanza" },
  { name: "Te Fuiste", link: "te-fuiste" },
  { name: "Ten Compasión De Mí", link: "ten-compasion-de-mi" },
  {
    name: "La Obscuridad Y La Luz Poema A Un Cometa",
    link: "la-obscuridad-y-la-luz-poema-a-un-cometa",
  },
  { name: "Nada Puedo Hacer", link: "nada-puedo-hacer" },
  { name: "La Lluvia Y Tú", link: "la-lluvia-y-tu" },
  { name: "Llanto", link: "llanto" },
];

export function getPoems() {
  return poems;
}

export function getTitles() {
  return titles;
}
